/**
 * Composes a band-style token's text (continuous/score metrics, Age) from its band-selector
 * state — this string is both what the chip in the search bar shows AND what gets submitted (per
 * the "search submits exactly what's on screen" rule), so there's no separate hidden NL-phrasing
 * step.
 *
 * `isAll`, specific preset bands, and a custom range are mutually exclusive ("SELECT ONE OR MORE
 * BANDS ... OR SET A CUSTOM RANGE" — the "or" is load-bearing): picking one clears the others.
 * That exclusivity is enforced by whatever calls this (BandSelector.js), not here — this function
 * only composes the display string from whichever one is currently active.
 *
 * `allDisplay`/`bandedPrefix` default to plain `metricDisplay` (Scores/Buckets' existing
 * "{display}" / "{display} of {bands}" shape) but are overridable — Age reads "All Ages" /
 * "Ages {bands}" instead, a different template rather than just different band labels.
 */
export function composeBandDisplay(
  metricDisplay,
  { isAll = true, selectedPresets = [], customRange = null } = {},
  { allDisplay = metricDisplay, bandedPrefix = `${metricDisplay} of` } = {}
) {
  if (isAll || (selectedPresets.length === 0 && !customRange)) {
    return allDisplay;
  }

  const bands = customRange ? [customRange] : selectedPresets;
  return `${bandedPrefix} ${bands.join(", ")}`;
}
